module.exports = __webpack_public_path__ + "img/single-img-18-p-500.51918ecb.jpg";